import {assert} from 'Asserts';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import DocumentStore from 'notebook/documents/DocumentStore';
import EntryStore from 'stores/EntryStore';
import APIUtil from 'util/APIUtil';
import StageEntryStore from 'workflows/stage-entries/StageEntryStore';

/**
 * Returns true if the Entry, Document, or StageEntry can be edited.
 *
 * @param entryId - an API identifier
 */
export default function isEntryEditable(entryId: string): boolean | undefined {
  const entryType = APIUtil.apiIdToType(entryId);
  if (entryType === ModelTypeConstants.STAGE_ENTRY) {
    return (
      StageEntryStore.inStore(entryId) &&
      StageEntryStore.getEditorState(entryId).stageEntryDocument.permissions.writable &&
      StageEntryStore.getVersionState(entryId).isLatest &&
      !StageEntryStore.getVersionState(entryId).dirty
    );
  } else if (entryType === ModelTypeConstants.DOCUMENT) {
    return (
      DocumentStore.inStore(entryId) &&
      DocumentStore.getEditorState(entryId).document.permissions.writable &&
      DocumentStore.getVersionState(entryId).isLatest &&
      !DocumentStore.getVersionState(entryId).dirty
    );
  } else {
    assert(entryType === ModelTypeConstants.ENTRY, 'Unexpected entry type', {entryId});
    return (
      EntryStore.inStore(entryId) &&
      EntryStore.getEditorState(entryId).entry.permissions.writable &&
      EntryStore.getVersionState(entryId).isLatest &&
      !EntryStore.getVersionState(entryId).dirty
    );
  }
}
